import axios from 'axios'
import interceptorsSetup from '@/helpers/interceptors'

const baseURL = process.env.VUE_APP_API_URL_V3 + '/bonus'

const bonusManagement = axios.create({
  baseURL
})

interceptorsSetup(bonusManagement)

export default class BonusManagement {
  static async get (bonusQuery) {
    const result = await bonusManagement.get('/' + bonusQuery.siteId, {})
    return result.data
  }
  static async saveBonus (bonus) {
    const result = await bonusManagement.post('/', bonus)
    return result.data
  }
  static async archiveBonus (bonus) {
    const result = await bonusManagement.put('/archive/' + bonus)
    return result.data
  }
}
